import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const RecipesSection = () => {
  const recipes = [
  {
    title: 'Pickle Paratha',
    description: 'Spicy stuffed flatbread with mango pickle filling',
    image: "/assets/images/pickle-paratha-1766911346652.jpg",
    alt: 'Golden crispy paratha stuffed with mango pickle on traditional brass plate with yogurt',
    prepTime: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Wheat flour', 'Mango pickle', 'Ghee', 'Coriander']
  },
  {
    title: 'Ghee Rice',
    description: 'Aromatic basmati rice cooked in pure deshi ghee',
    image: "/assets/images/ghee-rice-1766911289524.png",
    alt: 'Fragrant basmati rice with golden ghee and whole spices in traditional copper vessel',
    prepTime: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Basmati rice', 'Deshi ghee', 'Whole spices', 'Cashews']
  },
  {
    title: 'Murraba Smoothie',
    description: 'Healthy breakfast smoothie with amla murraba',
    image: "/assets/images/murraba-smoothie-1766911315179.jpg",
    alt: 'Creamy smoothie with amla murraba in glass with fresh fruits and mint garnish',
    prepTime: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Amla murraba', 'Yogurt', 'Honey', 'Banana']
  },
  {
    title: 'Pickle Sandwich',
    description: 'Quick snack with mixed vegetable pickle',
    image: "/assets/images/pickle-sandwitch-1766911225857.jpg",
    alt: 'Grilled sandwich with mixed vegetable pickle filling on wooden board with chips',
    prepTime: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Bread', 'Mixed pickle', 'Cheese', 'Butter']
  }];


  return (
    <section id="recipes" className="bg-card py-16 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-6">
        <div className="mb-12 text-center">
          <h2 className="font-heading mb-4 text-3xl font-bold text-foreground lg:text-4xl">
            <span className="text-primary">Recipe Ideas</span> & Usage
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Discover delicious ways to enjoy our traditional products
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {recipes?.map((recipe, index) =>
          <div
            key={index}
            className="group overflow-hidden rounded-2xl bg-background shadow-cta transition-all duration-250 ease-out hover:shadow-lg">

              <div className="relative h-56 overflow-hidden bg-muted">
                <AppImage
                src={recipe?.image}
                alt={recipe?.alt}
                className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110" />

                <div className="absolute right-4 top-4 rounded-full bg-primary px-3 py-1 text-xs font-bold text-primary-foreground">
                  {recipe?.difficulty}
                </div>
              </div>

              <div className="p-6">
                <h3 className="font-heading mb-2 text-xl font-bold text-foreground">
                  {recipe?.title}
                </h3>
                <p className="mb-4 text-sm text-muted-foreground">
                  {recipe?.description}
                </p>

                <div className="mb-4 flex items-center gap-4 text-sm text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="ClockIcon" size={16} className="text-primary" />
                    <span>{recipe?.prepTime}</span>
                  </div>
                </div>

                <div className="space-y-2">
                  <p className="text-xs font-bold text-foreground">
                    Key Ingredients:
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {recipe?.ingredients?.map((ingredient, i) =>
                  <span
                    key={i}
                    className="rounded-full bg-muted px-2 py-1 text-xs text-muted-foreground">

                        {ingredient}
                      </span>
                  )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 rounded-2xl bg-primary/5 p-8 text-center">
          <Icon
            name="BookOpenIcon"
            size={48}
            className="mx-auto mb-4 text-primary" />

          <h3 className="font-heading mb-2 text-2xl font-bold text-foreground">
            Want More Recipes?
          </h3>
          <p className="mb-6 text-muted-foreground">
            Get our free recipe book with 50+ traditional Indian recipes using
            our products
          </p>
          <button className="rounded-lg bg-primary px-8 py-3 font-cta text-base font-bold text-primary-foreground shadow-cta transition-all duration-250 ease-out hover:shadow-lg">
            Download Recipe Book
          </button>
        </div>
      </div>
    </section>);

};

export default RecipesSection;